import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import { useTemplateListingStore } from '../store';

export default function ShowOnlyAmpCheckBox() {
  const { onlyAmp, setOnlyAmp } = useTemplateListingStore();
  return (
    <Checkbox
      checked={onlyAmp}
      onChange={() => {
        setOnlyAmp(!onlyAmp);
      }}
    >
      <Tooltip
        placement="topRight"
        title="When checked, displays only AMP templates"
      >
        Show Only AMP?
      </Tooltip>
    </Checkbox>
  );
}
